import { APP_ROUTES } from 'shared/constants/navigation';

function hasBusinessDetails(webstore) {
    return Array.isArray(webstore?.Addresses) && webstore.Addresses.length > 0;
}

function redirectToVendorConnectOrFallback(tokenService, navigate) {
    const baseUrl = process.env.REACT_APP_VENDORCONNECT_URL;
    const refreshToken = tokenService?.getRefreshToken?.();

    if (!baseUrl || !refreshToken) {
        navigate(APP_ROUTES.vendor.dashboard);
        return;
    }

    const url = new URL(baseUrl);
    url.searchParams.set('token', refreshToken);
    window.location.assign(url.toString());
}

export { hasBusinessDetails, redirectToVendorConnectOrFallback };
